module.exports = __webpack_public_path__ + "ath_game_web/img/3.1.45190823.png";